import styled from 'styled-components';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom'
import { Color } from './common/theme'
import * as HomeConfig from './test/data/home.configs'
import HomeContent from './page/home'
import ClassContent from './page/class'
import PersonContent from './page/preson'
import { v4 as uuidv4 } from 'uuid';
import MessageContent from './page/message'

const toorbarHeight = HomeConfig.ToolBar.height
const headerHeight = HomeConfig.Header.height

const Header = styled.div`
  padding: 1px 0;
  margin: 0;
  border-bottom-left-radius:1rem;
  border-bottom-right-radius:1rem;
  width: 100%;
  background-color: ${Color.Primary};
  ${headerHeight>0 ? `height: ${headerHeight}rem` : ``};
  ${headerHeight > 0 ? `` : `padding-bottom: ${HomeConfig.ToolBar.height}rem`};
  
  @media screen and (max-width:290px){
    font-size:0.5rem;
  }
`

const SiteName = styled.div`
  background-color: rgba(255,255,255,0.9);
  border-top-left-radius:2rem;
  border-top-right-radius:2rem;
  border-bottom-left-radius:2rem;
  border-bottom-right-radius:2rem;
  line-height: 1.2rem;
  color: #000;
  text-align: center;
  height: 1.8rem;
`

const Banner = styled.div`
  
`

const Content = styled.div`
  border-top-left-radius:1rem;
  border-top-right-radius:1rem;
  margin:1rem;
  margin-top: ${HomeConfig.Content.top}rem;
  background-color: #fff;

  a{
    text-decoration:none;
  }

  @media screen and (max-width:290px){
    font-size:0.5rem;
  }
`

const ToolBar = styled.div`
  height: ${toorbarHeight}rem;
  margin-top: -${toorbarHeight}rem;
  padding: ${toorbarHeight / 3 / 2}rem;
  border-top: 1px solid #e3e3e3;
  z-index: 1000;
  background-color: #fff;
  color: ${Color.FontColor};
  img{
    height: ${toorbarHeight/3*2}rem;
    width:  ${toorbarHeight/3*2}rem;
  }
`

export default function App() {

  return (

  <BrowserRouter>
    <>
      <Header className="row">
        <Banner className="row p-0 m-0">
          <div className="col-3"></div>
          <SiteName className="col-6 pt-1 pb-1 mt-3 rounded-pill">
          睿华中学智慧校园
          </SiteName>
          <div className="col-3"></div>
        </Banner>
        <div className="row p-0 m-0">
          <img className="col" src="/assets/img/13113.png" alt="" />
        </div>
      </Header>
      <Content key={uuidv4()} className="row">
        <Routes key={uuidv4()}>
          <Route key={uuidv4()} path="/" element={<HomeContent key={uuidv4()}/>} />
          <Route key={uuidv4()} path="/class" element={<ClassContent key={uuidv4()}/>} />
            <Route key={uuidv4()} path="/person" element={<PersonContent key={uuidv4()} />} />
            <Route key={uuidv4()} path="/new/:id" element={<MessageContent key={uuidv4()} />} />
          <Route key={uuidv4()} path="*" element={<HomeContent key={uuidv4()} />} />
          </Routes>
          <div className="row py-0 my-3"><div className="col"></div></div>
      </Content>
        
      <ToolBar className="row fixed-bottom">
        <div className="col text-center" key={'home'}>
            <div className="row">
              <Link to="/"><img className="col" src="/assets/icon/toolbar_home.svg" alt="" /></Link>
            </div>
        </div>
        <div className="col text-center" key={'class'}>
            <div className="row">
              <Link to="/class"><img className="col" src="/assets/icon/toolbar_class.svg" alt="" /></Link>
            </div>
        </div>
        <div className="col text-center" key={'personal'}>
            <div className="row">
              <Link to="/person"><img className="col" src="/assets/icon/toolbar_person.svg" alt="" /></Link>
            </div>
        </div>
      </ToolBar>
      </>
    </BrowserRouter>
  );
}